export default __webpack_public_path__ + "static/media/aw.a4cfc016.svg";